import { NavigationMenu, NavigationMenuContent, NavigationMenuItem, NavigationMenuLink, NavigationMenuList, NavigationMenuTrigger, navigationMenuTriggerStyle } from "@/components/ui/navigation-menu";
import { cn } from "@/lib/utils";
import { Menu } from "lucide-react";
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth"
      });
    }
    setIsMenuOpen(false);
    navigate(`/#${id}`);
  };
  useEffect(() => {
    // Handle direct navigation to hash URLs
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth"
        });
      }
    }
  }, [location]);
  const navItems = [{
    id: "hero",
    label: "Welcome"
  }, {
    id: "features",
    label: "Property Features"
  }, {
    id: "gallery",
    label: "Photo Gallery"
  }, {
    id: "testimonials",
    label: "Guest Reviews"
  }, {
    id: "recommendations",
    label: "Local Tips"
  }, {
    id: "contact",
    label: "Contact Us"
  }, {
    id: "booking",
    label: "Book Now"
  }];
  return <div className="sticky top-0 z-50 w-full bg-white/80 backdrop-blur-sm border-b">
      <div className="container mx-auto py-4">
        <div className="flex items-center justify-between">
          <div className="text-xl font-bold text-primary">BeachBreak</div>

          <button className="lg:hidden p-2 hover:bg-accent rounded-md" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu">
            <Menu className="h-6 w-6" />
          </button>

          <div className="hidden lg:block">
            <NavigationMenu>
              <NavigationMenuList>
                {navItems.map(item => <NavigationMenuItem key={item.id}>
                    <NavigationMenuLink className={cn(navigationMenuTriggerStyle(), "cursor-pointer")} onClick={() => scrollToSection(item.id)}>
                      {item.label}
                    </NavigationMenuLink>
                  </NavigationMenuItem>)}
              </NavigationMenuList>
            </NavigationMenu>
          </div>
        </div>

        {isMenuOpen && <div className="lg:hidden mt-4 pb-4 fade-in">
            <nav className="flex flex-col space-y-2">
              {navItems.map(item => <button key={item.id} className="p-2 hover:bg-accent rounded-md text-left" onClick={() => scrollToSection(item.id)}>
                  {item.label}
                </button>)}
            </nav>
          </div>}
      </div>
    </div>;
};
export default Navigation;